import querystring from 'querystring';
import { jwtDecode } from 'jwt-decode';

import config from '../constants/config';
import { Backend } from '../services/backend';

class AuthApi {
    constructor() {
        this.path = '/uaa';
    }

    async authenticate({ grant_type, ...args }) {
        try {
            const credentials = btoa(
                `${config.CLIENT_ID}:${config.CLIENT_SECRET}`,
            );
            const authHeader = `Basic ${credentials}`;

            return await Backend.send({
                method: 'POST',
                url: `${this.path}/oauth2/token?${querystring.stringify({ grant_type, ...(config.COGNITO_ENABLED ? args : {}) })}`,
                headers: { Authorization: authHeader },
                body: config.COGNITO_ENABLED ? undefined : args,
            });
        } catch (e) {
            console.error('Error during cognito token exchange.');
            console.error(
                `Token exchange payload ${querystring.stringify(args)}`,
            );
            throw e;
        }
    }

    static async getUserInfo(auth) {
        return jwtDecode(auth.access_token);
    }
}

export { AuthApi };
